module.exports = __webpack_public_path__ + "img/pr-3.258056e3.png";